import { EventDateTimesModel, EventModel } from '../models/Events.model';
import { FeedItemDTO } from '../../feedItems/dtos/FeedItem.dto';
import {
  EventDateTimeRequestDTO,
  EventDateTimesDTO,
  EventFeedItemType,
  EventRequestDTO,
} from '../infra/types';
import { TagUtil } from '../../tags/utils/TagUtil';
import { generateUID } from '../../../../shared/components/toast/utils';

export class EventUtil {
  public static mapToViewModel(
    dto: FeedItemDTO<EventFeedItemType>,
  ): EventModel {
    return {
      id: dto.id,
      headline: dto.headline,
      tagline: dto.tagline,
      coverImage: dto.coverImage,
      body: dto.feedItem.body,
      location: dto.feedItem.location,
      dateTimes: dto.feedItem.dateTimes
        ? dto.feedItem.dateTimes.map((item) =>
            EventDateTimeUtil.mapToViewModel(item),
          )
        : [],
      access: dto.access,
      status: dto.status,
      tags: dto.tags ? dto.tags.map((tag) => TagUtil.mapToViewModel(tag)) : [],
      publishedOn: dto.publishedOn,
      recipients: dto.recipients,
      citationRequired: dto.citationRequired,
      feedType: 'EventItem',
    };
  }

  public static toRequestDTO(eventModel?: EventModel): EventRequestDTO {
    return {
      id: eventModel ? eventModel.id : undefined,
      headline: eventModel ? eventModel.headline : '',
      tagline: eventModel ? eventModel.tagline : undefined,
      body: eventModel ? eventModel.body : '',
      tags: eventModel ? eventModel.tags : [],
      coverImage: eventModel ? eventModel.coverImage : undefined,
      location: eventModel ? eventModel.location : '',
      citationRequired: eventModel ? eventModel.citationRequired : false,
      status: eventModel ? eventModel.status : 'DRAFT',
      dateTimes: eventModel
        ? eventModel.dateTimes
          ? eventModel.dateTimes.map((dt) => EventDateTimeUtil.toRequestDTO(dt))
          : []
        : [],
    };
  }
}

export class EventDateTimeUtil {
  public static mapToViewModel(dto: EventDateTimesDTO): EventDateTimesModel {
    return {
      id: dto.id,
      date: dto.date,
      startTime: dto.startTime,
      endTime: dto.endTime,
    };
  }

  public static toRequestDTO(
    eventDateTimeModel?: EventDateTimesModel,
  ): EventDateTimeRequestDTO {
    return {
      id: eventDateTimeModel ? eventDateTimeModel.id : generateUID(),
      date: eventDateTimeModel ? eventDateTimeModel.date : null,
      startTime: eventDateTimeModel ? eventDateTimeModel.startTime : undefined,
      endTime: eventDateTimeModel ? eventDateTimeModel.endTime : undefined,
    };
  }
}
